import { getUser, getUsersRef } from "db";
import { SHOW_ALERT } from "./ui";
import { createUser } from "db";
import { USER_STATUS } from "constants/user";

import { auth } from "helpers/firebase";

export const USER_SAVED = 'user_saved';
export const USER_FETCHED = 'user_fetched';
export const USERS_FETCHED = 'users_fetched';

export const createUserAction = (authUser) => (dispatch) => {
  if (!authUser) {
    return Promise.reject('authUser is requried!');
  }
  const { uid, photoURL, email, phoneNumber, displayName, } = authUser;
  if (!uid) {
    return Promise.reject('uid is required!');
  }

  const params = {
    birthday: null,
    email,
    name: displayName,
    gender: 0,
    intro: null,
    phone: phoneNumber,
    profile_image_url: photoURL,
    status: 0
  }

  return getUser(uid)
    .then(user => {
      if (user.exists) {
        console.log('Already exist');
        return Promise.resolve('already exist');
      } else {
        return createUser(uid, params);
      }
    })
    .catch(e => console.error(e))
}

export const getCurrentUserAction = () => (dispatch, getState) => {
  const { uid } = getState().auth.currentUser;
  if (!uid) {
    console.error('uid is required')
  }

  const checkUserStatus = (uid) => {
    return getUser(uid)
      .then((user) => {
        if (user.exists) {
          console.log("user = ", user.data());
          const { status = USER_STATUS.WAITING_FOR_REVIEW } = user.data();
          switch (status) {
            case USER_STATUS.WAITING_FOR_REVIEW: {
              alert("본 계정은 검토 대기 중입니다. 검토 후 승인되면 정상적으로 이용이 가능합니다. ");
              auth.signOut();
              break;
            }

            case USER_STATUS.IN_REVIEW: {
              alert("본 계정은 현재 검토중입니다. 검토 후 승인되면 정상적으로 이용이 가능합니다.");
              auth.signOut();
              break;
            }

            case USER_STATUS.REJECTED: {
              alert("본 계정은 검토과정에서 거부되었습니다. 재검토를 요청하려면 관리자에게 문의해주세요.");
              auth.signOut();
              break;
            }

            case USER_STATUS.READY: {
              dispatch({
                type: USER_FETCHED,
                payload: { user }
              })
              break;
            }

            default: {
              alert("본 계정의 상태가 비정상적입니다. 관리자에게 문의 바랍니다.");
            }
          }
        } else {
          // user is not exist, try again after 500ms later
          setInterval(() => {
            return checkUserStatus(uid)
          }, 500);
        }
      })
  }

  return checkUserStatus(uid);
}

export const getUsersAction = () => (dispatch, getState) => {
  const { uid } = getState().auth.currentUser;
  if (!uid) {
    console.error('uid is required')
  }
  return getUsersRef(uid).limit(50)
    .onSnapshot(users => {
      dispatch({
        type: USERS_FETCHED,
        payload: { users: users.docs }
      });
    }, e => {
      const message = e.code === 'permission-denied'
        ? '권한이 없습니다. 관리자에게 문의해주세요.'
        : `에러가 발생했습니다. ${e.message}`
      dispatch({
        type: SHOW_ALERT,
        payload: {
          message,
          color: 'danger',
        }
      })
    })
}